import { Component, inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from 'angular-reactive-validation';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { EmitsOnDestroyComponent } from '@qwyk/core';

import { MagayaNetworkConfigurationFacade } from '../../+state/magaya-network-configuration.facade';
import { MagayaNetworkConfigurationEntity } from '../../+state/magaya-network-configuration.models';

@Component({
    selector: 'qwyk-magaya-network-update',
    templateUrl: './magaya-network-update.component.html',
    styleUrls: ['./magaya-network-update.component.scss'],
})
export class MagayaNetworkUpdateComponent
    extends EmitsOnDestroyComponent
    implements OnDestroy
{
    private fb = inject(FormBuilder);
    private modal = inject(DynamicDialogRef);
    public config = inject(DynamicDialogConfig);
    private translate = inject(TranslateService);
    private configuration = inject(MagayaNetworkConfigurationFacade);

    public form: FormGroup;
    public error$ = this.configuration.error$;
    public loading$ = this.configuration.loading$;
    private entity: MagayaNetworkConfigurationEntity;

    constructor() {
        super();
        this.form = this.fb.group({
            superuser_username: [
                null,
                [
                    Validators.required(
                        this.translate.instant(
                            'hub.console.organizations.field-is-required',
                            {
                                value: this.translate
                                    .instant(
                                        'portal.registration.page1.label-username'
                                    )
                                    .toLowerCase(),
                            }
                        )
                    ),
                ],
            ],
            superuser_password: [
                null,
                [
                    Validators.required(
                        this.translate.instant(
                            'hub.console.organizations.field-is-required',
                            {
                                value: this.translate
                                    .instant('common.password')
                                    .toLowerCase(),
                            }
                        )
                    ),
                ],
            ],
        });
        this.configuration.updateMagayaNetworkConfigurationSuccessListener$
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.modal.close();
            });
    }

    public init(config: MagayaNetworkConfigurationEntity): void {
        this.entity = config;
        this.form.patchValue({ superuser_username: config.superuser_username });
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        this.configuration.dismissError();
    }

    onSubmit() {
        if (!this.entity) {
            throw new Error(
                this.translate.instant(
                    'hub.console.organizations.entity-not-initialized'
                )
            );
        }
        this.form.markAllAsTouched();
        if (this.form.invalid) {
            return;
        }

        this.configuration.update(this.entity, this.form.value);
    }

    onReset() {
        this.modal.close();
    }
}
